import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Block the automatic Chrome PWA install prompt across the entire app
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

